// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__jDxSN","info":"PatientInfo_info__j9wiT"};